<template>
  <base-multiselect
    class="custom-multiselect custom-multiselect-group"
    v-model="value2"
    :options="groupOptions"
    :multiple="multiple"
    :label="label"
    :track-by="trackBy"
    :selectLabel="selectLabel"
    :selectedLabel="selectedLabel"
    :deselectLabel="!allowEmpty ? '' : deselectLabel"
    :allow-empty="allowEmpty"
    :placeholder="placeholder"
    :disabled="disabled"
    group-values="children"
    group-label="text"
    :group-select="groupSelect"
    @select="change"
    @remove="deselected"
  >
    <span slot="noResult">ไม่มีข้อมูล</span>
    <span slot="noOptions">ไม่มีข้อมูล</span>
  </base-multiselect>
</template>

<script>
export default {
  name: "vue-multiselect-group",
  props: {
    selectedLabel: {
      type: String,
      default: "x",
    },
    selectLabel: {
      type: String,
      default: "",
    },
    deselectLabel: {
      type: String,
      default: "x",
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [Object, Array, String],
      default: null,
    },
    options: {
      type: Array,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "text",
    },
    trackBy: {
      type: String,
      default: "id",
    },
    placeholder: {
      type: String,
      default: "กรุณาเลือก",
    },
    groupSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value2: null,
      groupOptions: [],
    };
  },
  methods: {
    change(event) {
      const _tmp = event;
      this.$emit("input", _tmp);
      this.$emit("change", _tmp);
    },
    deselected(event) {
      const _tmp = null;
      this.$emit("input", _tmp);
      this.$emit("change", _tmp);
    },
  },
  mounted() {
    this.value2 = this.value;
  },
  watch: {
    value: {
      handler: function (val) {
        this.value2 = val;
      },
      deep: true,
    },
    options: {
      handler: function (val) {
        if (val) {
          this.groupOptions =
            val
              .filter((f) => f.parentId == null)
              .map((m) => {
                const children = val.filter((f) => f.parentId == m.id);

                return {
                  isParent: true,
                  id: m.id,
                  text: m.text,
                  children: [...children],
                };
              }) || [];
        } else {
          this.groupOptions = [];
        }
      },
      deep: true,
    },
  },
};
</script>
